<template>
  <div class="main">
    <TopCtrl/>
    <EmptyListTip
      :icon="icon"
      :text="text"
      />
  </div>
  
</template>

<script>
export default {
  title: '抱歉',
  bodyClass: 'gray-bg',
  components: {},
  data(){
    return {
        icon: '',
        text: ''
    }
  },
  mounted(){
    //设置图标
    this.icon = this.$route.query.icon || "//res.uuudian.com/hk_data/573136ab-6c83-4cb1-8125-9f124913cb1c";
    //设置文本
    this.text = this.$route.query.text;
    //设置标题
    if(this.$route.query.title){
      setTimeout(()=>{
        document.title = this.$route.query.title;
      }, 500);
    }
  }
}
</script>

<style scoped lang="less">

</style>




// WEBPACK FOOTER //
// src/pages/public/Sorry.vue